module.exports = __webpack_public_path__ + "assets/img/5.c4981027.jpg";